<div class="hbox">
  <div class="flex-box">
    <div class="flex-heading">
      <div class="col-xs-12 list-header">
        <ul class="breadcrumb">
          <li><a routerLink="/products/catalogs/hero-ingredient">Hero Ingredients</a></li>
          <li>{{heroIngredient && heroIngredient.id ? 'Edit' : 'New' }}</li>
        </ul>
      </div>
    </div>
    <div class="flex-content">
      <form class="col-xs-12 p-4" #heroIngredientForm="ngForm">
        <div class="col-xs-6">
          <label class="col-xs-4 mt-0">Title</label>
          <div class="col-xs-12">
            <language-string-selection [parseObj]="heroIngredient" [tags]="['hero-ingredient-title']" [name]="'nameLanguageString'" [required]="true"></language-string-selection>
          </div>
        </div>
        <div class="col-xs-6">
        <label class="col-xs-4 mt-0">Description</label>
          <div class="col-xs-12">
            <language-string-selection [parseObj]="heroIngredient" [tags]="['hero-ingredient-description']" [name]="'descriptionLanguageString'" [required]="true"></language-string-selection>
          </div>
        </div>
        <div class="block col-xs-6">
          <label class="col-xs-4 mt-2">Priority</label>
          <div class="col-xs-12">
            <input type="number" class="form-control" name="priority" [(ngModel)]="priority" (ngModelChange)="onPriorityChange($event)" [required]="true">
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-4">Image</label>
          <div class="col-xs-12 m-r-xs flex">
            <input-image-upload [parseObj]="heroIngredient" name="image" [required]="true" [accept]="'image/png, image/jpg, image/jpeg'" [imageLimit]="1" [constraints]="{ size: 150000, aspectRadio: [1], tolerance: 0.02 }"></input-image-upload>
          </div>
        </div>
      </form>
      <div class="mt-2 ml-4">
        <button type="submit" [disabled]="!heroIngredientForm.valid" (click)="saveHeroIngredient()">{{ heroIngredient.id ? 'Update' : 'Create' }}</button>
      </div>
    </div>
  </div>
</div>
